export default {
    
    indexDynamicJoins:           { method: 'get',    url: 'dynamic_joins' },
    createDynamicJoin:           { method: 'post',   url: 'dynamic_joins'},
    updateDynamicJoin:           { method: 'put',    url: 'dynamic_joins/{id}'},
    deleteDynamicJoin:           { method: 'delete', url: 'dynamic_joins/{id}'},
    generateDynamicJoin:         { method: 'put',    url: 'dynamic_joins/{id}/generate' },
    syncDynamicJoin:             { method: 'put',    url: 'dynamic_joins/{id}/sync' },
    showDynamicJoinViewResults:  { method: 'get',    url: 'dynamic_joins/{id}/view-results' },
    indexDynamicJoinStatus:      { method: 'get',    url: 'dynamic_joins/status' },
    
}